import { Directive } from '@angular/core';
import { PolicyUpdateMetadata } from 'src/app/_types/lead.types';
import { getInsuranceTypeLabel } from 'src/app/enums/insurance-type.enum';
import { getPeriodicityLabel } from 'src/app/enums/proposal.enums';

import { BaseMetadataComponent } from '../base-metadata.component';

@Directive()
export abstract class PolicyUpdateMetadataComponentAbstract extends BaseMetadataComponent<PolicyUpdateMetadata> {
  getInsuranceTypeLabel = getInsuranceTypeLabel;

  getPeriodicityLabel = getPeriodicityLabel;
}
